import useFormatDateTime from '@/utils/hooks/format/useFormatDateTime';
import useFormatNumber from '@/utils/hooks/format/useFormatNumber';
import { useFormatTimeIndicator } from '@/utils/hooks/format/useFormatTimeIndicator';
import useUser from '@/utils/hooks/swr/useUser';

import Icon from '@/components/base/Icon';

export const useTableAndCSVData = () => {
    const { user } = useUser({
        revalidateOnMount: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    const { formatNumber } = useFormatNumber(user?.settings?.numbers_format ?? 'comma');
    const { formatDateTimeNoTz } = useFormatDateTime(user?.settings?.timezone);
    const { formatHour } = useFormatTimeIndicator();

    const format = ({
        tAnalytics,
        tCommons,
        formatterTranslation,
        isEstimatedChart = false,
        isExport = false,
        key,
        timeFormat,
        value,
        valueFormat
    }) => {
        switch (key) {
            case 'date':
                return formatDateTimeNoTz(value, user?.settings?.date_format);

            case 'date_hour':
                return formatHour(value);

            case 'time':
                return timeFormat(value);

            case 'post_engagements':
                return tAnalytics(`chart.post_engagements.${value}`);

            case 'day':
                return (tCommons ?? tAnalytics)(`days.${value}`);

            case 'month':
                return tAnalytics(`chart.time_unit.${value}`);

            case 'age':
            case 'language':
            case 'country':
            case 'city':
            case 'name':
            case 'percentage_formatted':
            case 'domain':
                return value;

            case 'type':
                if (formatterTranslation) {
                    return tAnalytics(`${formatterTranslation}.${value}`);
                }
                return tAnalytics(value);

            case 'reaction':
                return isExport ? (
                    value
                ) : (
                    <Icon
                        className="text-base text-icoGray-500 dark:text-icoDarkMode-wolf"
                        icon={`${value}-reaction`}
                    />
                );
            case 'percentage_male':
            case 'percentage':
            case 'percentage_female':
                return formatNumber(value * 100, valueFormat) + '%';
            default:
                if (value || value === 0) {
                    if (valueFormat) {
                        return formatNumber(value, valueFormat);
                    }
                    return value;
                }
                return isEstimatedChart ? '-' : 'N/A';
        }
    };

    return { format };
};
